<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-chip color="green" label small v-bind="attrs" v-on="on"
        >{{ qtdAulasConfirmadas }}/{{ qtdAulas }}</v-chip
      >
    </template>
    <span>
      <div>
        Aulas confirmadas: {{ qtdAulasConfirmadas }}
        <br />
        Aulas aguardando confirmação: {{ qtdAulasAguardandoConfirmacao }}
      </div>
    </span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    qtdAulas: {
      type: Number,
      required: true,
    },
    qtdAulasConfirmadas: {
      type: Number,
      required: true,
    },
    qtdAulasAguardandoConfirmacao: {
      type: Number,
      required: true,
    },
  },
  computed: {
    // qtdAulasAprovadas() {
    //   return this.aulas.filter((aula) => aula.situacao === "Aula confirmada").length;
    // },
    // qtdAulas() {
    //   return this.aulas.length;
    // },
    // resumoAulas() {
    //   const resumo = this.aulas.reduce((accumulator, aula) => {
    //     const situacao = aula.situacao || "Aguardando confirmação";
    //     accumulator[situacao] = Number.isInteger(accumulator[situacao])
    //       ? accumulator[situacao] + 1
    //       : 1;
    //     return accumulator;
    //   }, []);
    //   return resumo;
    // },
  },
};
</script>

<style></style>
